import { gql } from '@apollo/client';

export const GET_COMPANIES = gql`
  query getAdminsCompanies($amount: Float!, $offset: Float!, $sortBy: SortByField, $id: String, $name: String) {
    getCompanies(
      input: { amount: $amount, offset: $offset, searchOptions: { name: $name, id: $id }, sortBy: $sortBy }
    ) {
      count
      companies {
        ...CompanyFields
        createdOn
        createdBy {
          ...CompanyUserFields
        }
      }
    }
  }
`;
